// El detalle de inventario recibe todos los centros y almacenes seleccionados en una consulta.
export const parametrosDetalle = (pestania: string, filas: any[]): string[] => {
    if (pestania === "inventario") {
        const centros = new Set<string>();
        const almacenes = new Set<string>();
        filas.forEach(fila => {
            const centro = String(fila.Centro ?? "").trim();
            const almacen = String(fila.Almacen ?? "").trim();
            if (!centro || !almacen) throw new Error("Falta centro o almacén en la selección.");
            centros.add(centro);
            almacenes.add(almacen);
        });
        return centros.size
            ? [`centros=${encodeURIComponent(Array.from(centros).join("|"))}&almacenes=${encodeURIComponent(Array.from(almacenes).join("|"))}`]
            : [];
    }

    const referencia = pestania === "subinventario" ? "Subinventario_Id" : "Reconteo_ref";
    const parametro = pestania === "subinventario" ? "subInventarios" : "Reconteos";
    const items = filas.map(fila => {
        const campos = ["Centro", "Almacen", referencia].map(campo => String(fila[campo] ?? "").trim());
        if (campos.some(campo => !campo)) throw new Error("Faltan datos en los registros seleccionados.");
        return campos.join(";");
    });
    return items.length ? [`${parametro}=${encodeURIComponent(Array.from(new Set(items)).join("-"))}`] : [];
};
